// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const WIKI_REVIEWS = "Centrum recenzi\u00ed";
